/* Praevaleo Warenkorb-Fach (wie insomne): eigenes Fach statt Horizon-Fach.
   Inhalt kommt als Liquid aus sections/pv-cart-drawer (Section Rendering API), die Seite /cart nutzt denselben Inhalt.
   Horizon-Fach ist stillgelegt: nicht eingebunden, gespeicherter Öffnungszustand wird gelöscht. */
(() => {
  if (window.__pvCart) return;
  window.__pvCart = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const page = () => $('[data-pv-cart-page]');
  let el = null, busy = false, lastFocus = null;

  function tame() {
    try {
      const v = sessionStorage.getItem('theme-drawer-open') || '';
      if (/cart/.test(v)) sessionStorage.removeItem('theme-drawer-open');
    } catch (e) {}
    $$('.page-wrapper--drawer-open').forEach((w) => { if (!$('dialog.theme-drawer__dialog[open]')) w.classList.remove('page-wrapper--drawer-open'); });
    $$('cart-drawer-component[auto-open]').forEach((c) => c.removeAttribute('auto-open'));
  }
  tame();

  function mount() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'pv-cd';
    el.id = 'pv-cart';
    el.hidden = true;
    el.innerHTML = '<div class="pv-cd__back" data-pv-cart-close></div><aside class="pv-cd__panel" role="dialog" aria-modal="true" aria-labelledby="pv-cart-heading"><div class="pv-cd__inner" data-pv-cd-inner><div class="pv-cart pv-cart--drawer"><div class="pv-cart__head"><h2 class="pv-cart__title" id="pv-cart-heading">Warenkorb</h2><button type="button" class="pv-cart__x" data-pv-cart-close aria-label="Schließen"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div></div></div></aside>';
    document.body.appendChild(el);
    return el;
  }

  function setCount(n) {
    $$('[data-pv-cart-count]').forEach((c) => { c.textContent = n; c.hidden = !n; });
    $$('[data-pv-cart-open]').forEach((a) => a.setAttribute('aria-label', 'Warenkorb, ' + n + (n === 1 ? ' Teil' : ' Teile')));
  }

  // Neuer Inhalt rein; <pv-combine> bleibt stehen, wenn sich die Teile nicht geändert haben (kein Flackern).
  function swap(host, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-pv-cart-body]', doc);
    if (!fresh) return;
    const oldC = $('pv-combine', host), newC = $('pv-combine', fresh);
    if (oldC && newC && oldC.dataset.ids === newC.dataset.ids && oldC.dataset.types === newC.dataset.types) newC.replaceWith(oldC);
    const cur = $('[data-pv-cart-body]', host);
    if (cur) cur.replaceWith(fresh); else host.replaceChildren(fresh);
    setCount(+fresh.dataset.count || 0);
  }

  // Geschenk fällt raus, wenn der Warenwert ohne Schmuck unter das Ziel rutscht (Fehlerbericht 02.11.).
  async function dropGift() {
    const b = $('[data-pv-cart-body][data-gift-goal]');
    if (!b) return false;
    const goal = +b.dataset.giftGoal, ids = (b.dataset.giftIds || '').split(',');
    const c = await fetch(root + 'cart.js').then((r) => r.json());
    // Nur das Geschenk selbst (beim Wählen markiert oder 0 €), gekaufter Schmuck bleibt liegen.
    const gifts = c.items.filter((i) => ids.includes(String(i.variant_id)) && ((i.properties && i.properties._pv_geschenk) || i.final_line_price === 0));
    if (!gifts.length) return false;
    const kauf = c.items.filter((i) => !ids.includes(String(i.variant_id))).reduce((s, i) => s + i.final_line_price, 0);
    if (kauf >= goal) return false;
    const updates = {};
    gifts.forEach((g) => (updates[g.key] = 0));
    await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
    return true;
  }

  async function refresh(again) {
    const p = page();
    let hadBody = !!$('[data-pv-cart-body][data-gift-goal]');
    try {
      if (hadBody) { try { await dropGift(); } catch (e) {} }
      if (p) {
        // Auf /cart liefert „Accept: application/json“ das Warenkorb-JSON statt der Section, darum ohne diesen Kopf.
        const id = p.dataset.section;
        const j = await fetch(root + 'cart?sections=' + encodeURIComponent(id)).then((r) => r.json());
        if (j[id]) swap(p, j[id]);
      }
      if (el && !el.hidden) {
        const j = await fetch(root + '?sections=pv-cart-drawer', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        if (j['pv-cart-drawer']) swap($('[data-pv-cd-inner]', el), j['pv-cart-drawer']);
      } else if (!p) {
        const c = await fetch(root + 'cart.js').then((r) => r.json());
        setCount(c.item_count);
      }
      // Erstes Laden des Fachs: jetzt ist das Ziel bekannt, einmal nachprüfen.
      if (!hadBody && !again && $('[data-pv-cart-body][data-gift-goal]')) { let d = false; try { d = await dropGift(); } catch (e) {} if (d) return refresh(true); }
    } catch (e) {}
  }

  async function open() {
    if (page()) { refresh(); return; }
    mount();
    if (el.hidden) lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    document.documentElement.classList.add('pv-lock');
    // Fokus aufs Fach selbst statt auf das X: kein Fokusrahmen beim Öffnen, Tab führt trotzdem hinein.
    const panel = $('.pv-cd__panel', el);
    if (panel) { panel.setAttribute('tabindex', '-1'); panel.focus({ preventScroll: true }); }
    await refresh();
  }
  function close() {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    el.hidden = true;
    document.documentElement.classList.remove('pv-lock');
    const t = lastFocus && lastFocus.isConnected ? lastFocus : $('[data-pv-cart-open]');
    t && t.focus && t.focus({ preventScroll: true });
  }
  window.pvOpenCart = open;

  async function change(key, quantity, body) {
    if (busy) return;
    busy = true;
    body.classList.add('is-busy');
    let msg = '';
    try {
      const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      if (!r.ok) msg = r.status === 422 ? 'Von diesem Teil ist nicht mehr genug auf Lager.' : 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
    } catch (e) { msg = 'Keine Verbindung. Bitte versuch es noch einmal.'; }
    await refresh();
    busy = false;
    $$('[data-pv-cart-body]').forEach((b) => b.classList.remove('is-busy'));
    if (msg) $$('[data-pv-cart-err]').forEach((m) => (m.textContent = msg));
  }

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('[data-pv-cart-close]')) { e.preventDefault(); close(); return; }
    const opener = t.closest('[data-pv-cart-open], .pv-drawer__cart');
    if (opener && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      if (page()) return; // auf /cart normal weiter
      e.preventDefault();
      const menu = $('[data-pv-drawer]');
      if (menu && !menu.hidden) $('[data-pv-drawer-close]', menu)?.click();
      open();
      return;
    }
    const body = t.closest('[data-pv-cart-body]');
    if (!body) return;
    const line = t.closest('.pv-line');
    const q = t.closest('[data-pv-q]');
    if (line && q) { change(line.dataset.key, Math.max(0, +line.dataset.qty + +q.dataset.pvQ), body); return; }
    if (line && t.closest('[data-pv-rm]')) { change(line.dataset.key, 0, body); return; }
  });

  // Hinzufügen irgendwo im Shop (Produktseite, Look, Geschenk, Vorschlag im Fach) meldet cart:update.
  document.addEventListener('cart:update', (e) => {
    const src = (e.detail && (e.detail.data && e.detail.data.source)) || (e.detail && e.detail.sourceId) || '';
    const inside = e.target instanceof Element && e.target.closest && e.target.closest('#pv-cart, [data-pv-cart-page]');
    if (inside || /pv-gift|pv-combine/.test(String(src))) { refresh(); return; }
    if (e.detail && e.detail.data && e.detail.data.didError) return;
    if (page()) refresh(); else open();
  });

  document.addEventListener('keydown', (e) => {
    if (!el || el.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      const f = $$('a[href],button:not([disabled]),input,select', el).filter((x) => x.offsetParent);
      if (!f.length) return;
      const a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
})();
